<template>
  <div>
    <div>
      <FxedTop></FxedTop>
    </div>
    <div class="page">
      <div class="container">
        <div class="containent">
          <!-- 课程选择 -->
          <!-- <div class="courseType">
            <div class="typeHalf" id="1" @click="selectCourse">
              <div :class="[type == 1 ? 'border_b' : '', 'typeLeft']">
                <img :src="curriculumIcon2" style="width: 82px; height: 81px" />
                <div :class="type == 1 ? 'typeConActive' : 'typeCon'">
                  <div>秒懂学堂</div>
                </div>
              </div>
              <img class="triangle" v-show="type == 1" :src="curriculumIcon7" />
            </div>
            <div class="typeHalf" id="2" @click="selectCourse">
              <div :class="[type == 2 ? 'border_b' : '', 'typeLeft']">
                <img
                  :src="curriculumIcon3"
                  style="width: 143px; height: 68px; margin-top: 7px" />
                <div :class="type == 2 ? 'typeConActive' : 'typeCon'">
                  <div>海外学院</div>
                </div>
              </div>
              <img class="triangle" v-show="type == 2" :src="curriculumIcon7" />
            </div>
            <div class="typeHalf" id="3" @click="selectCourse">
              <div :class="[type == 3 ? 'border_b' : '', 'typeLeft']">
                <img
                  :src="curriculumIcon1"
                  style="width: 75px; height: 76px; margin-top: 3px" />
                <div :class="type == 3 ? 'typeConActive' : 'typeCon'">
                  <div>我的课程</div>
                </div>
              </div>
              <img class="triangle" v-show="type == 3" :src="curriculumIcon7" />
            </div>
          </div> -->

          <div class="main" :style="{ 'margin-top': marginT + 'px' }">
            <!-- <div class="" v-if="type == 3">
              <div class="courseStatus">
                <div class="typeStatus">
                  <img
                    :src="curriculumIcon4"
                    style="width: 36px; height: 36px; margin-left: 10px" />
                  <div class="statusText">
                    已完成课程{{ userCurriculum.completeSectionNum }}节
                  </div>
                </div>
                <div class="typeStatus">
                  <img
                    :src="curriculumIcon5"
                    style="width: 38px; height: 43px" />
                  <div class="statusText">
                    已结业{{ userCurriculum.completeClassNum }}门
                  </div>
                </div>
                <div class="typeStatus">
                  <img
                    :src="curriculumIcon6"
                    style="width: 34px; height: 41px" />
                  <div class="statusText">
                    已超越{{ userCurriculum.overMemberNum }}人
                  </div>
                </div>
              </div>
              <div class="mainList">
                <div v-if="courseList && courseList.length">
                  <div
                    class="items"
                    @click="goCourseList(item)"
                    v-for="(item, index) in courseList"
                    :key="index">
                    <img class="leftImg" :src="item.iconImgSrc" />
                    <div class="rightCon">
                      <div class="titleLeft">{{ item.name }}</div>
                      <div class="text">共{{ item.sectionNum }}个小节</div>
                      <div class="progress">
                        <div class="proBg">
                          <div
                            class="proDetail"
                            :style="{ width: `${item.speedRate}%` }"></div>
                        </div>
                        <div>学习进度</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="noCoures">暂未加入课程</div>
              </div>
            </div> -->
            <div class="mainList">
              <!-- <div v-for="(item, index) in curriculumList" :key="index">
                <div
                  v-if="
                    curriculumList.length > 0 &&
                    item.showType &&
                    item.showType != 'class'
                  "> -->
              <!-- <div class="items" @click="classDetailClick(index)">
                    <img class="leftImg" :src="item.groupLogo" />
                    <div class="rightCon">
                      <img
                        class="arrow"
                        :class="arrowIdx === index ? '' : 'arrowNo'"
                        :src="arrow" />
                      <div class="titleLeft">{{ item.groupName }}</div>
                    </div>
                  </div> -->
              <div class="detailList">
                <div
                  v-for="(itemm, indexx) in curriculumList"
                  :key="indexx"
                  style="border-bottom: 1px solid #dcdcdc"
                  class="items"
                  @click="goCourseList(itemm)">
                  <img
                    class="leftImg"
                    style="zoom: 0.86"
                    :src="itemm.iconImgSrc" />
                  <div class="rightCon">
                    <div class="titleLeft">{{ itemm.name }}</div>
                    <div class="p_r">
                      <div
                        v-if="itemm.chapterNum != null"
                        style="width: 220px"
                        class="text">
                        共{{ itemm.chapterNum }}个小节
                      </div>
                      <div v-else class="text" style="width: 220px">
                        共{{ itemm.sectionNum }}个小节
                      </div>
                      <div class="progress">
                        <div class="proBg">
                          <div
                            v-if="itemm.maxMember != 0"
                            class="proDetail"
                            :style="{
                              width: `${
                                (itemm.joinMember / itemm.maxMember) * 100
                              }%`,
                            }"></div>
                          <div v-else class="proDetail" style="width: 0%"></div>
                        </div>
                        <div v-if="itemm.maxMember != 0">
                          {{ itemm.joinMember }}人/{{ itemm.maxMember }}人
                        </div>
                        <div v-else>当前:{{ itemm.joinMember }}人</div>
                      </div>
                    </div>
                  </div>
                  <!-- </div>
                  </div> -->
                </div>
              </div>
              <div class="noCoures" v-if="curriculumList.length == 0">
                {{ tipText }}
              </div>
              <div
                v-if="
                  curriculumList.length > 0 &&
                  curriculumList[0].showType &&
                  curriculumList[0].showType == 'class'
                ">
                <div class="detailList" style="">
                  <div
                    v-for="(itemm, index) in curriculumList"
                    :key="index"
                    style="border-bottom: 2px solid #dcdcdc"
                    class="items"
                    @click="goCourseList(itemm)">
                    <img
                      class="leftImg"
                      style="zoom: 0.86"
                      :src="itemm.iconImgSrc" />
                    <div class="rightCon">
                      <div class="titleLeft">{{ itemm.name }}</div>
                      <div class="p_r">
                        <div
                          v-if="itemm.chapterNum != null"
                          style="width: 220px"
                          class="text">
                          共{{ itemm.chapterNum }}个小节
                        </div>
                        <div v-else class="text" style="width: 220px">
                          共{{ itemm.sectionNum }}个小节
                        </div>
                        <div class="progress">
                          <div class="proBg">
                            <div
                              v-if="itemm.maxMember != 0"
                              class="proDetail"
                              :style="{
                                width: `${
                                  (itemm.joinMember / itemm.maxMember) * 100
                                }%`,
                              }"></div>
                            <div
                              v-else
                              class="proDetail"
                              style="width: 0%"></div>
                          </div>
                          <div v-if="itemm.maxMember != 0">
                            {{ itemm.joinMember }}人/{{ itemm.maxMember }}人
                          </div>
                          <div v-else>当前:{{ itemm.joinMember }}人</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let uni = {};
import { IMAGES_PATH, IMAGES_URL } from "@/utils/config2.js";
import {
  getcurriculum,
  getInfo,
  getSubscribeTmpId,
} from "@/api/wkApi.js";
import FxedTop from "@/components/FxedTop";
export default {
  components: {
    FxedTop,
  },
  data() {
    return {
      arrow: IMAGES_PATH + "/images/arrow.png",
      imgs1: IMAGES_PATH + "/images/yuan.png",
      arrowIdx: 0,
      curriculumIcon1: IMAGES_URL + "my_class.png",
      curriculumIcon2: IMAGES_URL + "pic_md.png",
      curriculumIcon3: IMAGES_URL + "pic_hd.png",
      curriculumIcon4: IMAGES_URL + "vector_1.png",
      curriculumIcon5: IMAGES_URL + "vector_2.png",
      curriculumIcon6: IMAGES_URL + "vector_3.png",
      curriculumIcon7: IMAGES_URL + "triangle.png",
      slideshow: IMAGES_PATH + "/images/microlecture/slideshow.png",
      search: IMAGES_PATH + "/images/microlecture/search.png",
      indicatorDots: true,
      vertical: false,
      infoPageNum: 1,
      userInfo: {},
      curriculumList: [],
      inputValue: "",
      userCurriculum: {},
      type: 1, // 1 微课秒懂 2 海外学院 3 我的课程
      courseList: {},
      marginT: 0,
      tipText: "暂无课程",
    };
  },
  // 上拉加载
  onReachBottom() {
    console.log("上拉加载");
    if (this.type == 1) {
    } else if (this.type == 2) {
    } else if (this.type == 3) {
      this.infoPageNum += 1;
      this.selectUser();
    }
  },
  watch: {
    type: function () {
      this.infoPageNum = 1;
    },
  },
  created() {
    // this.$common.Init.call(this);
    // const action = options.action || "";
    // if (action == "confirm") {
    //   const { classId } = JSON.parse(uni.getStorageSync("courseInfo") || "{}");
    //   subscribe({
    //     classId: classId,
    //   }).then((res) => {
    //     if (res.data.code == 200) {
    //       uni.navigateTo({
    //         url: "/pages/classRoom/courseList?id=" + classId,
    //       });
    //     } else {
    //       uni.showToast({
    //         title: res.data.msg,
    //         icon: "none",
    //       });
    //     }
    //   });
    // }
    // this.selectUser();
    this.getCurriculum();

    // if (options.list) {
    //   let currJson = JSON.parse(options.list);
    //   this.type = -1;
    this.marginT = 19;
    //   console.log(currJson);
    //   if (currJson.length > 0) {
    //     this.curriculumList = currJson;
    //   } else {
    //     this.tipText = "暂未搜索到相关课程，请换个关键字再搜索";
    //   }
    // } else {
    //   const openIdObj = uni.getStorageSync("openId") || "{}";
    //   const { openid: openId } = JSON.parse(openIdObj) || {};
    //   let params = {
    //     openId,
    //     status: 1,
    //     pageNum: 1,
    //     type: this.type,
    //     pageSize: 10,
    //   };
    //   this.getCurriculum(params);
    // }
  },
  methods: {
    classDetailClick(index) {
      var arrowIdx = this.arrowIdx;
      this.arrowIdx = arrowIdx === index ? false : index;
    },

    selectCourse(e) {
      this.type = e.currentTarget.id;
      this.marginT = 0;
      if (this.type == 3) {
        this.selectUser();
      } else {
        this.getCurriculum();
      }
    },

    // 获取课程列表
    getCurriculum() {
      getcurriculum({ classGroupId: this.$route.query.groupId }).then((res) => {
        this.curriculumList = res.result.list;
        if (this.curriculumList.length == 0) {
          this.tipText = "暂无课程";
        }
      });
    },

    /* goMyCourse() {
				this.register('/pages/classRoom/myCourse');
			},

			goAllCourse() {
				this.register('/pages/classRoom/allCourse');
			}, */

    // 判断是否完善信息
    register(url) {
      uni.navigateTo({
        url: url,
      });
    },
    // 订阅
    goCourseList(item) {
      if (item.isOpen == 0) {
        return uni.showToast({
          title: "暂未开放,敬请期待",
          icon: "none",
        });
      }
      let id = item.id;
      if (!item.needSubscribe) {
        this.$router.push({
          path: "/course/courseList",
          query: { id },
        });
        return;
      }
      uni.setStorageSync(
        "courseInfo",
        JSON.stringify({
          classId: id,
        })
      );
      getSubscribeTmpId().then((res) => {
        const { templateId } = res.result.records || {};
        const redirect_url = encodeURIComponent(location.href);
        const { appId } = JSON.parse(uni.getStorageSync("userInfo") || "{}");
        const href = `https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=${appId}&scene=${id}&templateId=${templateId}&redirect_url=${redirect_url}#wechat_redirect`;
        console.log(href, "href");
        location.href = href;
      });
    },
    selectUser() {
      var pageSize = 20;
      let params = {
        pageSize,
        pageNum: this.infoPageNum,
      };
      getInfo(params).then((res) => {
        var arr = res.result.list || [];
        if (arr.length == 0) {
          // uni.showToast({
          //   title: "到底啦",
          //   icon: "none",
          // });
        }
        if (this.infoPageNum > 1) {
          this.courseList.concat(arr);
        } else {
          this.courseList = arr;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
}

.detailList {
  display: block;
  border-top: 4px solid #dcdcdc;
  background-color: #f6f6f6;
  padding: 10px 20px 28px 60px;
  box-sizing: border-box;
}

.p_r {
  display: flex;
  flex-direction: row;
  width: 80vw;
  margin-top: 20px;
}

.arrowNo {
  transform: rotate(270deg);
}

.arrow {
  width: 34px;
  height: 32px;
  position: absolute;
  right: 40px;
  margin-top: 10px;
}

.courseType {
  width: 100%;
  min-height: 140px;
  margin: 12px auto 0;
  display: flex;
  .typeHalf {
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.typeStatus {
  width: 33.3%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.statusText {
  font-size: 24px;
  color: #481c87;
  margin-left: 8px;
}

.typeLeft {
  width: 100%;
  padding: 16px 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 2px solid #cdcdcd;
  box-sizing: border-box;
}

.typeHalf:last-child .typeLeft {
  border-right: none;
}

.border_b {
  border-bottom: 4px solid #aacd22;
}

.typeCon {
  font-size: 30px;
  font-weight: 600;
  color: #cdcdcd;
  margin-top: 8px;
}

.typeConActive {
  font-size: 30px;
  font-weight: 600;
  color: #481c87;
  margin-top: 8px;
}

.triangle {
  width: 26px;
  height: 19px;
  margin-top: 6px;
}

.text {
  font-size: 24px;
  color: #5e5e5e;
  font-weight: 500;
}

.main {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 10px 28px 40px;
  .courseStatus {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #f6f6f6;
    border-radius: 24px;
  }
  .mainTitle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .titleRight {
      font-size: 24px;
      color: #868686;
      line-height: 40px;
    }
  }
  .titleLeft {
    font-size: 30px;
    width: 400px;
    font-weight: 600;
    color: #481c87;
    line-height: 40px;
  }
  .items {
    position: relative;
    display: flex;
    border-bottom: 1px solid #f2f2f2;
    padding: 24px 30px;
    .progress {
      font-size: 24px;
      font-weight: 400;
      color: #481c87;
      display: flex;
      align-items: center;
      .proBg {
        width: 200px;
        height: 10px;
        background-color: #efefef;
        border-radius: 20px;
        .proDetail {
          width: 100px;
          height: 10px;
          background-color: #aacd22;
          border-radius: 20px;
        }
      }
    }
    .leftImg {
      width: 80px;
      height: 80px;
      margin-right: 30px;
    }

    .rightCon {
      width: 100%;
      .titleLeft {
        width: 90%;
        font-size: 30px;
        font-weight: 600;
        color: #481c87;
        line-height: 40px;
      }
      .text {
        width: 400px;
        font-size: 24px;
        color: #5e5e5e;
        font-weight: 500;
      }
    }
  }
}

.noCoures {
  font-size: 24px;
  text-align: center;
  color: #cdcdcd;
  margin-top: 20px;
}
</style>
